import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { SeasonalRentalService } from '@app/listing/services/seasonal-rental.service';
import Workflow from '@app/models/workflow';
import WorkflowStep from '@app/models/workflow-step';
import { WorkflowService, BackgroundCheckService, } from '@app/services';


@Component({
    selector: 'pmt-confirm-ret',
    templateUrl: './pmt-confirm-ret.component.html',
    styleUrls: ['./pmt-confirm-ret.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class PmtConfirmRetComponent implements OnInit {
  paymentIntentId: string;
  status: string = '';
  msg: string = 'Checking payment status...';
  showContinueButton: boolean = true;
  showPurchaseButton: boolean = false;  
  private workflow: Workflow;
  private hasBackgroundCheck: boolean = false;

  constructor(
    private route: ActivatedRoute, 
    private router: Router,
    private seasonalRentalService: SeasonalRentalService,
    private workflowService: WorkflowService,
    private backgroundCheckService: BackgroundCheckService) {

      this.route.queryParams.subscribe({
        next: params => {
          this.paymentIntentId = params['payment_intent'];
        }
      })

      localStorage.removeItem("clientSecret");

      // rebuild workflow in case we need to do background check
      
      // configure Workflow
      // Create the workflow from the steps in seasonalRentalService.seasonalRentalAvailableWorkflowSteps,
      // add it to the workflowService, and subscribe to workflowService.workflowStepCompleted subject
      let workflow = { name: 'Seasonal Rental Booking Workflow', code: 'SRBW', steps: [] } as Workflow;
  
      // Load the workflow steps from the available steps
      this.seasonalRentalService.seasonalRentalAvailableWorkflowSteps.forEach((s) => {
        let workflowStep = {} as WorkflowStep;
  
        workflowStep.name = s.route;
        workflowStep.route = s.route;
        workflowStep.showCosts = s.showCosts;
        workflowStep.step = s.route;
        workflowStep.isComplete = s.complete;
        workflowStep.category = s.step;
  
        workflow.steps.push(workflowStep);
      });
  
      this.workflowService.addWorkflow(workflow, true);
  
      this.workflow = workflow;

      // mark steps complete before redirect
      this.workflowService.setStepCompleted(this.workflow.name, 'signin');
      this.workflowService.setStepCompleted(this.workflow.name, 'contact-info');
      this.workflowService.setStepCompleted(this.workflow.name, 'contact-info');
      this.workflowService.setStepCompleted(this.workflow.name, 'payment-terms');
      this.workflowService.setStepCompleted(this.workflow.name, 'create-payment-intent');
      
  
  }

  ngOnInit(): void {
    this.getBackgroundCheckStatus();

    // restore current purchaseRequest
    this.seasonalRentalService.currentPurchaseRequest = JSON.parse(localStorage.getItem('currentPurchaseRequest'));

    // call API to get this correctly from Stripe PaymentIntent
    this.seasonalRentalService.checkStripePaymentIntentStatus(this.paymentIntentId).subscribe({
      next: (result) => {
        this.status = result;
        
        if (this.status == 'requires_capture') {
          this.msg = "Completing reservation...";
          // payment was authorized so process the purchase
          this.seasonalRentalService.purchase(this.paymentIntentId).subscribe(
            (result) => {
              const data = { reservationId: result.reservationId };
              console.log("Purchase successful", result);
              this.workflowService.setStepCompleted(this.workflow.name, 'payment');
              const incompleteSteps = this.workflowService.getIncompleteSteps(this.workflow.name);

              if (incompleteSteps.length > 0) {
                const nextStep = incompleteSteps[0];
          
                //let navigationOptions = { skipLocationChange: true, relativeTo: this.route, queryParamsHandling: 'merge' } as NavigationExtras;
          
                //navigationOptions.queryParams = this.getRouteQueryParameterData();
          
                this.router.navigate(['/listing', result.listingId, 'seasonal-rental', nextStep.route]);

              } else {
                // navigate here or to finished?
                this.router.navigate(['/user/trips/upcoming']); 
              }
              
            },
            (resp) => {
              console.log("Purchase failed", resp);
              this.showContinueButton = false;
              this.msg = 'Payment was authorized but reservation processing failed!';
            }
          );
        } else {
          this.msg = this.status;
          this.showContinueButton = false;
        }
      },
      error: (err) => {
        console.log("Error checking payment intent status", err);
        this.msg = 'Error checking payment intent status';
        this.showContinueButton = false;
      }
    });
  }
  
  private getBackgroundCheckStatus() {
    this.backgroundCheckService
      .getStatus()
      //.pipe(takeUntil(this.unSubSub$))
      .subscribe((res) => {
        if (res.status && res.status.toLowerCase() !== 'none') {
          this.workflowService.setStepCompleted(this.workflow.name, 'background-check');
          this.workflowService.setStepCompleted(this.workflow.name, 'background-check-disclosure');
          this.workflowService.setStepCompleted(this.workflow.name, 'background-check-auth');
        }
      });
  }

}
